import React, {useEffect, useState} from 'react';
import {formatToPersianAddCommaNegativeToParentheses} from "../../../../utils/CommaSeparator";

const ShowPriceProfitReport = ({data}) => {

  const [showPrice, setShowPrice] = useState(0)

  useEffect(() => {
    let data_1 = data?.part_1?.data.reduce((sum, item) => sum + +item.totalRemaining, 0)
    let data_2 = data?.part_2?.data.reduce((sum, item) => sum + +item.totalRemaining, 0)
    let data_3 = data?.part_3?.data.reduce((sum, item) => sum + +item.totalRemaining, 0)
    let data_4 = data?.part_4?.data.reduce((sum, item) => sum + +item.totalRemaining, 0)

    setShowPrice(data_1 - (data_2 + data_3 + data_4))
  }, [data]);

  return (
    <div className={"row-show-price"}>
      <h6>سود و زیان خالص</h6>
      <h6>{formatToPersianAddCommaNegativeToParentheses(showPrice)}</h6>
    </div>
  );
};

export default ShowPriceProfitReport;